import React, { useState, useEffect, useCallback, useReducer } from 'react';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import usePrevious from 'utils/customHook/usePrevious';
import useCancellationToken from 'utils/customHook/useCancellationToken';
import { customAxiosGetFunction } from 'utils/axiosFunction';
import { getYMDAndTimeFormatDate } from 'utils/getCustomFormatDate';
import LineGraph from './LineGraph';
import { nvl } from 'utils/nvl';

import { GasDetailGraphContainer } from './GasDetailGraph.css.js';
import { graphOrder } from 'utils/code';

const GasDetailGraph = ({ searchMap, gasCriterion }) => {
  const history = useHistory();
  const cancellationToken = useCancellationToken();
  const [data, setData] = useState([]);
  const { date, moduleIdx, beginDate, endDate } = searchMap;
  const prevAmount = usePrevious({ date, moduleIdx, beginDate, endDate }, cancellationToken.isCancelled);

  const searchGasGraph = useCallback(() => {
    customAxiosGetFunction(history, '/api/gas/search/graph', {
      params: {
        moduleIdx: searchMap.moduleIdx,
        beginDate: getYMDAndTimeFormatDate(searchMap.beginDate),
        endDate: getYMDAndTimeFormatDate(searchMap.endDate),
      },
    }).then((response) => {
      if (cancellationToken.isCancelled || nvl(response, null) === null) {
        return false;
      }

      setData(response);
    });
  }, [searchMap, cancellationToken]);

  useEffect(() => {
    if (!cancellationToken.isCancelled && prevAmount != searchMap) {
      searchGasGraph();
    }
  }, [searchMap, cancellationToken]);

  useEffect(() => () => cancellationToken.cancel(), []);

  const createLineGraphComponent = graphOrder[searchMap.moduleScn].map((key) => {
    return (
      <LineGraph
        key={key}
        graphId={key}
        data={data.map((d) => {
          return nvl(d[key], 0);
        })}
        categories={data.map((d) => {
          return d.minRgstDt === d.maxRgstDt
            ? `${moment(d.maxRgstDt).format('YYYY-MM-DD HH:mm:ss')}`
            : `${moment(d.minRgstDt).format('YYYY-MM-DD HH:mm:ss')} ~ ${moment(d.maxRgstDt).format('YYYY-MM-DD HH:mm:ss')}`;
        })}
        criterion={gasCriterion[key]}
      />
    );
  });

  return <GasDetailGraphContainer>{createLineGraphComponent}</GasDetailGraphContainer>;
};

export default GasDetailGraph;
